export var SourceFileStatus = /* @__PURE__ */ ((SourceFileStatus2) => {
  SourceFileStatus2["New"] = "New";
  SourceFileStatus2["Uploaded"] = "Uploaded";
  SourceFileStatus2["Processing"] = "Processing";
  SourceFileStatus2["Validated"] = "Validated";
  SourceFileStatus2["ValidationError"] = "ValidationError";
  return SourceFileStatus2;
})(SourceFileStatus || {});
